var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket-picker"},_vm._l((_vm.tickets),function(t,i){return (t.type===0)?_c('ticket-card',{key:i,attrs:{"ticket":t,"active":_vm.picked === t.id},on:{"clicked":function($event){return _vm.onSelect(t)}}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }